<script>
    export let icon;
    export let text;
    export let link;
</script>

<a class="button" href={link} target="_blank" rel="noopener noreferrer"><img src={icon}/>{text}</a>

<style>
    .button {
        width: 160px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FF0000;
        border-radius: 8px;
        border: none;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 0;
        color: #FFFFFF;
    }

    .button img {
        width: 24px;
        margin-right: 10px;
    }
</style>
